import { useEffect, useState } from 'react';

export const useDebouncedLoading = (loading: boolean, duration = 500) => {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShowLoading(false);
      return;
    }

    const timeout = setTimeout(() => {
      setShowLoading(loading);
    }, duration);

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return showLoading;
};
